export class KryptonConstants {
    static servletNameRegex: RegExp = /^\/WebDispatch\//i;
    static optimizeMemory: boolean = false;
    static defaultFormTarget: string = "opener";
    static allowMultiplePages: boolean = false; //-- faster response times when closing pages, more memory, more complex
    static servletName: string = "WebDispatch";

    /*animation timings*/
    static showHideAnimationTime = 500;
    static showHideIntermediateAnimationTime = 50;
    static revealAnimationTime = 150;
    static layerOpenAnimationTime = 100;
    static scrollBufferTime = 400;
    static horizontalSlideAnimationTime = 600;
    static notificationDismissMultiplier = 750;
    static notificationAnimationTime = 350;
}